var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask"},[_c('div',{staticClass:"show"},[_c('a',{staticClass:"link"},[_c('img',{staticClass:"showimg",attrs:{"src":_vm.close_pic},on:{"click":_vm.fn}})]),_c('a',{staticClass:"link",on:{"click":_vm.gotoPath}},[_c('img',{staticStyle:{"width":"568px","height":"130px"},attrs:{"src":_vm.image}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }